import React from 'react';

import { COMPONENT_BASE_CLASS } from '../constants';

function Marker() {
  return <div className={`${COMPONENT_BASE_CLASS}__marker`}></div>;
}

export default Marker;
